export default "__VITE_ASSET__DDyY15zF__"